module.exports = __webpack_public_path__ + "static/img/openvip_SVIP.97b744f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/openvip_SVIP.png
// module id = D0GP
// module chunks = 1